// extracted by mini-css-extract-plugin
module.exports = {"banner":"T_dj","icon":"T_cy","title":"T_7","text":"T_cd","button":"T_by"};